import { useRouter } from 'next/router'

import { Button } from '@wartek-id/button-v1'
import { Dialog, DialogOverlay, DialogContent } from '@wartek-id/dialog-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'
import { useToast } from '@wartek-id/toast'

import { assetUrl } from 'utils/url'
import { useAPIPostPelaksanaanAppealRollback } from 'api/kinerja/useAPIKinerja'

import type { TPelaksanaanAppealableStep } from 'types/kinerja-pelaksanaan'

type DialogPelaksanaanAppealRollbackProps = Omit<DialogProps, 'children'> & {
  onCancel?: () => void
  url: string
  step: TPelaksanaanAppealableStep
}

export function DialogPelaksanaanAppealRollback({
  onCancel,
  step,
  url,
  ...dialogProps
}: DialogPelaksanaanAppealRollbackProps) {
  const router = useRouter()
  const toast = useToast()
  const mutationPelaksanaanAppealRollback =
    useAPIPostPelaksanaanAppealRollback()

  const handleConfirm = () => {
    mutationPelaksanaanAppealRollback.mutate(
      { appealState: step },
      {
        onSuccess: () => {
          router.push(url)
        },
        onError: () => {
          toast({
            message: 'Gagal lanjut. Coba lagi.',
          })
        },
      }
    )
  }

  return (
    <Dialog size="sm" {...dialogProps}>
      <DialogOverlay />
      <DialogContent>
        <div className="p-6 space-y-4">
          <img
            src={assetUrl('/illustrations/img-document-sync-data.png')}
            alt=""
            height={84}
            width={84}
          />

          <div className="space-y-1">
            <Text variant="display-sm">
              Jika lanjut ubah, dokumen akan menjadi draf dan harus dikumpulkan
              ulang
            </Text>
            <Text color="subdued" variant="body-lg">
              Pastikan Anda kumpulkan dokumen setelah selesai ubah.
            </Text>
          </div>
          <div className="flex space-x-5">
            <Button
              onClick={onCancel}
              color="white"
              size="lg"
              disabled={mutationPelaksanaanAppealRollback.isLoading}
            >
              Kembali
            </Button>
            <Button
              onClick={handleConfirm}
              color="blue"
              size="lg"
              isLoading={mutationPelaksanaanAppealRollback.isLoading}
              disabled={mutationPelaksanaanAppealRollback.isLoading}
            >
              Lanjut ubah
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
